import homeVideo from "fragments/homeVideos/homeVideo"
import gql from "graphql-tag"

const UPDATE_HOME_VIDEO = gql`
  ${homeVideo}

  mutation updateHomeVideo(
    $id: ID!
    $homeVideoUpdateInput: HomeVideoUpdateInput!
    $storeLinksUpdateInput: [StoreLinkUpdateInput]
  ) {
    updateHomeVideo(
      id: $id
      homeVideoUpdateInput: $homeVideoUpdateInput
      storeLinksUpdateInput: $storeLinksUpdateInput
    ) {
      ...HomeVideo
    }
  }
`

export default UPDATE_HOME_VIDEO
